import { useDataValue } from 'Simple/Data.js'

/** @type {import('Simple/types.js').useDataConfiguration} */
export default function useDataConfiguration(props) {
  let id = useDataValue({
    viewPath: props.viewPath,
    context: 'auth',
    path: 'access_token_data.lead_id',
  })

  return {
    variables: {
      id,
    },
    pause: !id,
  }
}
